$(document).on('click', '.print-trigger', function() {
  window.print();
});